import React from "react";
import { PanelContent } from "@sonder/ui/source/styled/layouts/PanelContent";
import { TaskData } from "core/queries/GetTask";
import { AttachmentsCard } from "tasks/components/TaskPanel/Details/AttachmentsCard";
import { ChecklistCard } from "tasks/components/TaskPanel/Details/ChecklistCard";
import { CleaningInfoCard } from "tasks/components/TaskPanel/Details/CleaningInfoCard";
import { HoldDepositCard } from "tasks/components/TaskPanel/Details/HoldDepositCard";
import { InternalHoldCard } from "tasks/components/TaskPanel/Details/InternalHoldCard";
import { MetadataCard } from "tasks/components/TaskPanel/Details/MetadataCard";
import { NotesCard } from "tasks/components/TaskPanel/Details/NotesCard";
import { TagsCard } from "tasks/components/TaskPanel/Details/TagsCard";

interface DetailsProps {
  task: TaskData;
}
export const Details = ({ task }: DetailsProps) => (
  <PanelContent>
    <NotesCard task={task} />
    <TagsCard task={task} />
    <MetadataCard task={task} />
    <CleaningInfoCard task={task} />
    <HoldDepositCard task={task} />
    <InternalHoldCard task={task} />
    <AttachmentsCard task={task} />
    <ChecklistCard task={task} />
  </PanelContent>
);
